import {
  HHBaseTable,
  HHButton,
  HHStack,
} from '@hinge-health/react-component-library';
import {
  formatSubscriptionTier,
  IRevenueShare,
} from '../../utils/discount-utils';
import { ScopeDisplay } from '../scope-display/scope-display';
import { TextGrouping } from '../utils/text-grouping';

export interface RevenueShareDetailProps {
  revenueShare: IRevenueShare;
  handleEditRevenueShareClick?: (revenueShareDefinitionId: number) => void;
}

export const REVENUE_SHARE_DETAIL_TEST_ID = 'revenue-share-detail-test-id';

const RevenueShareDetail = ({
  revenueShare,
  handleEditRevenueShareClick,
}: RevenueShareDetailProps): JSX.Element => (
  <HHStack
    direction="column"
    spacing={4}
    padding={4}
    data-testid={REVENUE_SHARE_DETAIL_TEST_ID}
  >
    <ScopeDisplay scopes={revenueShare.scopes} />
    <HHStack direction="row" spacing={6}>
      <TextGrouping
        label="Apply to Price"
        text={revenueShare.applyToPrice ? 'Yes' : 'No'}
      />
    </HHStack>
    <HHBaseTable
      headerRowBottomBorder="1px solid rgba(0, 0, 0, 0.12)"
      bodyRowBorder={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}
      bodyTypographyVariant="inherit"
      tableHeaders={[
        { value: 'Tier', align: 'left' as const },
        { value: 'Subscriptions per Tier', align: 'left' as const },
        { value: 'Rev Share %', align: 'left' as const },
      ]}
      bodyContent={revenueShare.details.map(row => ({
        tier: { value: row.tier },
        subscriptionTier: {
          value: formatSubscriptionTier(row.subscriptionTier),
        },
        discount: { value: `${row.discount}%` },
      }))}
    />
    {handleEditRevenueShareClick && (
      <HHStack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="end"
      >
        <HHButton
          hhVariant="variant-bypass"
          variant="outlined"
          size="medium"
          color="primary"
          onClick={(): void => {
            handleEditRevenueShareClick(revenueShare.revenueShareDefinitionId);
          }}
        >
          Edit
        </HHButton>
      </HHStack>
    )}
  </HHStack>
);

export default RevenueShareDetail;
